import { createFileRoute } from '@tanstack/react-router';
import { PAGE_PATHS } from '../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/workflows/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.WORKFLOWS });
    context.validatePermissions({ isAllowed, preload });
  },
});
